import type { FC } from 'react';
import React from 'react';

import { CalendarNav, CalendarNext, CalendarPrev, CalendarToday } from '@mobiscroll/react';
import { Box, InputAdornment, TextField, Typography, useTheme } from '@mui/material';

import { CrossSmallIcon } from '@setup/svg-icons/svg-icons';
import { palette } from '@setup/theme/palette';
import { formatDateForView } from '@shared/utils/formatDateForView';

import { DatePickerCustomHeaderContainer } from './DatePickerCustomHeader.style';

type DatePickerCustomHeaderProps = {
  value: any;
  onChange: (date: any) => void;
  dateFormat?: string;
  placeholder?: string;
  inputName?: string;
  isClearable?: boolean;
};
const DatePickerCustomHeader: FC<DatePickerCustomHeaderProps> = ({
  value,
  dateFormat,
  onChange,
  inputName,
  placeholder,
  isClearable,
}) => {
  const theme = useTheme();

  const handleClearValue = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    onChange?.(null);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ width: '100%', p: '12px 0' }}>
        <TextField
          fullWidth
          value={formatDateForView(value, dateFormat || 'MM/DD/YYYY')}
          placeholder={placeholder}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '4px',
              gap: '0px',
              border: `0.5px solid ${theme.palette.case.neutral.n200}`,
              height: '32px',

              '& .MuiOutlinedInput-input:not(:placeholder-shown)': { color: palette.case.aquamarine.a700 },
            },

            '.MuiInputBase-inputAdornedStart': {
              marginLeft: '0',
            },
          }}
          InputProps={{
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">
                <Typography color={theme.palette.case.neutral.n500} variant={'t14r'}>
                  {inputName}
                </Typography>
              </InputAdornment>
            ),
            endAdornment:
              isClearable && !!value ? (
                <InputAdornment position="end">
                  <Box
                    onClick={handleClearValue}
                    sx={{
                      position: 'relative',
                      zIndex: '100',
                      width: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer !important',
                      color: `${theme.palette.case.neutral.n700} !important`,

                      svg: {
                        path: {
                          fill: 'currentcolor',
                        },
                      },
                      '&:hover': {
                        opacity: '0.7',
                      },
                    }}
                  >
                    <CrossSmallIcon />
                  </Box>
                </InputAdornment>
              ) : null,
          }}
        />
      </Box>

      <DatePickerCustomHeaderContainer mb="12px">
        <CalendarNav />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ mr: '8px' }}>
            <CalendarToday />
          </Box>
          <Box sx={{ mr: '3px' }}>
            <CalendarPrev />
          </Box>
          <CalendarNext />
        </Box>
      </DatePickerCustomHeaderContainer>
    </Box>
  );
};

export default DatePickerCustomHeader;
